import React from "react";
import AddCustomer from "../../../Features/Forms/Customers/Add";

const Add = () => {
  return (
    <div>
      <AddCustomer />
    </div>
  );
};

export default Add;
